/* eslint-disable max-lines */
import styled, { keyframes } from 'styled-components';
import { border, layout, space, color, typography, flexbox, shadow } from 'styled-system';

const load = keyframes({
  '0%, 100%': { opacity: 0.2 },
  '50%': { opacity: 0.6 }
});

const LoadingBox = styled.div`
  position: relative;
  overflow: hidden;
  animation: ${load} 1.2s ease infinite;
  ${layout}
  ${space}
    ${color}
    ${typography}
    ${flexbox}
    ${border}
    ${shadow}
`;

export default LoadingBox;
